var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushsubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_18295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_18295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15V15H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_18295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 6.375H13.125V4.875C13.125 4.66875 12.9563 4.5 12.75 4.5H12C11.7937 4.5 11.625 4.66875 11.625 4.875V6.375H10.125C9.91875 6.375 9.75 6.54375 9.75 6.75V7.5C9.75 7.70625 9.91875 7.875 10.125 7.875H11.625V9.375C11.625 9.58125 11.7937 9.75 12 9.75H12.75C12.9563 9.75 13.125 9.58125 13.125 9.375V7.875H14.625C14.8313 7.875 15 7.70625 15 7.5V6.75C15 6.54375 14.8313 6.375 14.625 6.375ZM5.25 7.5C6.90703 7.5 8.25 6.15703 8.25 4.5C8.25 2.84297 6.90703 1.5 5.25 1.5C3.59297 1.5 2.25 2.84297 2.25 4.5C2.25 6.15703 3.59297 7.5 5.25 7.5ZM7.35 8.25H6.95859C6.43828 8.48906 5.85938 8.625 5.25 8.625C4.64062 8.625 4.06406 8.48906 3.54141 8.25H3.15C1.41094 8.25 0 9.66097 0 11.4V12.375C0 12.9961 0.503906 13.5 1.125 13.5H9.375C9.99607 13.5 10.5 12.9961 10.5 12.375V11.4C10.5 9.66097 9.08903 8.25 7.35 8.25Z",
    fill: "#FF754C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_18295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushsubscription);
export default __webpack_public_path__ + "static/media/pushsubscription.21de422a8a159b13c05a619f2d3466cb.svg";
export { ForwardRef as ReactComponent };